import { defineMessages } from 'react-intl'

const scope = `procurify.modules.purchasing.feature-sets.po-terms-methods-view`

export default defineMessages({
  headingShippingTerms: {
    id: `${scope}.headingShippingTerms`,
    defaultMessage: 'Purchase order shipping terms',
  },
  headingPaymentTerms: {
    id: `${scope}.headingPaymentTerms`,
    defaultMessage: 'Purchase order payment terms',
  },
  headingShippingMethods: {
    id: `${scope}.headingShippingMethods`,
    defaultMessage: 'Purchase order shipping methods',
  },
  descriptionShippingTerms: {
    id: `${scope}.descriptionShippingTerms`,
    defaultMessage:
      'Purchase order shipping terms will be selectable in the Vendor management page.',
  },
  descriptionPaymentTerms: {
    id: `${scope}.descriptionPaymentTerms`,
    defaultMessage:
      'Purchase order payment terms will be selectable in the Vendor management page.',
  },
  descriptionShippingMethods: {
    id: `${scope}.descriptionShippingMethods`,
    defaultMessage:
      'Purchase order shipping methods will be selectable in the Vendor management page.',
  },
  newButtonShippingTerms: {
    id: `${scope}.newButtonShippingTerms`,
    defaultMessage: 'New shipping terms',
  },
  newButtonPaymentTerms: {
    id: `${scope}.newButtonPaymentTerms`,
    defaultMessage: 'New payment terms',
  },
  newButtonShippingMethods: {
    id: `${scope}.newButtonShippingMethods`,
    defaultMessage: 'New shipping method',
  },
  createModalTitleShippingTerms: {
    id: `${scope}.createModalTitleShippingTerms`,
    defaultMessage: 'Create shipping terms',
  },
  createModalTitlePaymentTerms: {
    id: `${scope}.createModalTitlePaymentTerms`,
    defaultMessage: 'Create payment terms',
  },
  createModalTitleShippingMethods: {
    id: `${scope}.createModalTitleShippingMethods`,
    defaultMessage: 'Create shipping method',
  },
})
